var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DefaultLayout',{attrs:{"full-width-header":_vm.fullWidthHeader},scopedSlots:_vm._u([(_vm.isMobileListingPage)?{key:"mobile-map-controls",fn:function(){return [_c('map-controls')]},proxy:true}:null],null,true)},[_c('router-view',{attrs:{"id":"city-shell"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }